import RecognitionDirectAtCard from "./RecognitionDirectAtCard";

export default RecognitionDirectAtCard;
